import React from 'react';
import styled from 'styled-components';
import * as BuilderInfoUI from '../../BuilderInfoUI';
import { isNotNil } from '../../../../utils/types';
import { getCharacterByIncrementedIndex } from '../../../../utils/character';
import { RollingControlDisplay } from '../../../RollingControlDisplay';
import BuilderInfoLabelList from '../BuilderInfoLabelList';
import EventConditionInfo from '../EventConditionInfo';
import { IBuilderSimpleMeasureInfo } from './parseMeasureInfo';
import SimpleMeasureFormatDisplay from './SimpleMeasureFormatDisplay';
import { getPercentileValue } from '../../../../utils/builder/percentile';
import { theme } from '../../../../styles/theme';
import { SvgIcon } from '../../../Icon';
import BadgeRound from '../../../BadgeRound';

interface IProps extends IBuilderSimpleMeasureInfo {
  rowIndex?: number;
}

const ContentContainer = styled(BuilderInfoUI.GridColumns)`
  padding: 8px;
`;

const FunctionContainer = styled(BuilderInfoUI.PlainInfo)`
  margin-top: 4px;
`;

const RollingControlWrapper = styled.div`
  color: ${theme.colors.mainBlue};
`;

export default ({ simpleMeasure, cohorts, rowIndex }: IProps) => {
  const {
    id,
    function: fn,
    eventConditions,
    percentile,
    rollingControl,
    version,
    format,
  } = simpleMeasure;

  // XXX KB-6021 - display percentile number as a whole % instead of a fraction (multiply by 100)
  const functionDisplay =
    fn.requirePercentile && percentile
      ? `${fn.name} (${getPercentileValue(percentile)}%)`
      : fn.name;
  const measureLabel = isNotNil(rowIndex)
    ? getCharacterByIncrementedIndex('A', rowIndex)
    : undefined;

  return (
    <>
      <BuilderInfoUI.BorderedSection>
        <BuilderInfoUI.BorderedSectionHeader>
          {measureLabel && <BadgeRound size="small">{measureLabel}</BadgeRound>}
          {version?.name && <BuilderInfoLabelList items={[version.name]} />}
          {rollingControl && (
            <RollingControlWrapper>
              <RollingControlDisplay
                rollingFunction={rollingControl.function}
                value={rollingControl.window}
              />
            </RollingControlWrapper>
          )}
        </BuilderInfoUI.BorderedSectionHeader>
        <ContentContainer>
          <FunctionContainer>
            <BuilderInfoUI.InfoLabel>Measure by</BuilderInfoUI.InfoLabel>
            <BuilderInfoLabelList items={[functionDisplay]} />
          </FunctionContainer>
          <div>
            {eventConditions.map((eventCondition, index) => (
              <EventConditionInfo
                key={id + '_' + index}
                condition={eventCondition}
                showProperty={true}
                label={'Event(s)'}
              />
            ))}
          </div>
        </ContentContainer>
        {format && <SimpleMeasureFormatDisplay format={format} />}
      </BuilderInfoUI.BorderedSection>
      {cohorts?.length > 0 && (
        <SvgIcon name="formula-cohort" width={14} height={14} isActive />
      )}
    </>
  );
};
